jQuery(document).ready(function() {
  
  var pv_delivery_msg = '';
  var pv_minimum_order = 0;
  var pv_cart_amount = 0;
  var pv_state = '';
  
  jQuery('.cart__submit').prop( "disabled", true ).hide();
    
    jQuery.ajax({
      type: 'POST',
      // url: 'https://shopifyapps.concise.digital/postcode_validator/cart_response.php?mode=info&shop_url=food-for-reasons.myshopify.com',
      url: '/apps/tc-pcv/cart_response.php?mode=info&shop_url=food-for-reasons.myshopify.com',
      crossDomain: true,
      data: '',
      success: function(responseData, textStatus, jqXHR) {
          var resp = responseData;
          if(resp!="") {
          	jQuery('#single_image').attr("href", resp);
            jQuery('#single_image').text("See our map here.");
          }
          else
            jQuery('#single_image').hide();
      },
      error: function (responseData, textStatus, errorThrown) {
        console.log(errorThrown);
      }
    }); 
});

function addZ(n){return n<10? '0'+n:''+n;}

function getCutOff(day, hour) {
    var date_now = new Date();
    var date_now_day = date_now.getDay();
    var date_diff = 0;
    var date_cutoff = new Date();

    date_diff = date_now_day - day;
    date_cutoff.setDate(date_cutoff.getDate() - date_diff);
    date_cutoff = new Date(date_cutoff.getFullYear(), date_cutoff.getMonth(), date_cutoff.getDate(), hour, 0, 0, 0);
    
    return date_cutoff;
}

function getNextWeekMonday() {
    var d = new Date();
    var diff = d.getDate() - d.getDay() + 1;
    if (d.getDay() == 0)
        diff -= 7;
    diff += 7; 

    return new Date(d.setDate(diff));
}

function getNextWeekAfterMonday(days) {
    var d = getNextWeekMonday();

    return new Date(d.setDate(d.getDate() + days));
}

jQuery('body').on('click', '#pv_postcode_submit', function () {  
  jQuery.getJSON('/cart.js', function(cart) {
    //console.log(cart);
    pv_cart_amount = cart.total_price;

    jQuery.ajax({
      type: 'POST',
      // url: 'https://shopifyapps.concise.digital/postcode_validator/cart_response.php?shop_url=food-for-reasons.myshopify.com&postcode='+jQuery('#pv_postcode_text').val(),
      url: '/apps/tc-pcv/cart_response.php?shop_url=food-for-reasons.myshopify.com&postcode='+jQuery('#pv_postcode_text').val(),
      crossDomain: true,
      data: '{ "product_id": "' + product_ids + '" }',
      success: function(responseData, textStatus, jqXHR) {
        var resp = responseData.split('|||');
        if(resp[0]=="Valid") {
           pv_minimum_order = resp[3]; 
           pv_delivery_msg = resp[4];
           pv_state = resp[5].toLowerCase();
          
           jQuery('#pv_postcode_submit').val('Change');

          if((eval(pv_cart_amount)/100)>=eval(pv_minimum_order)) {              
            var pv_delivery_msg='<div class="pv_postcode">' + pv_delivery_msg + '</div>';
            jQuery('div.pv_shipping_msg.pv_d-flex_end').show();

            jQuery('#pv_delivery_msg').html(pv_delivery_msg);
            jQuery('#pv_undeliverable_msg').hide();
            jQuery('.cart__submit').prop( "disabled", false ).show();                

            //date
            //             var pv_delivery_date ='<div class="pv_delivery_date"><p class="cart-attribute__field"><label for="delivery-date">Delivery Date</label><input required class="required" id="delivery-date" type="text" name="attributes[Delivery-Date]" value="{{ cart.attributes["Delivery-Date"] }}"></p></div>';       

            //time
            /*var pv_delivery_time ='<div class="pv_delivery_time"><p class="cart-attribute__field"><label for="delivery-time">Delivery Time</label><select required class="required" id="delivery-time" name="attributes[Delivery Time]">';
            var timetemp = resp[1].split(',');

            for (t = 0; t < timetemp.length; t++) { 
              pv_delivery_time = pv_delivery_time + '<option value="' + timetemp[t] + '">' + timetemp[t] + '</option>';
            }

            pv_delivery_time = pv_delivery_time + '</select></div>';*/

            //             jQuery('#pv_postcode_response').html(pv_delivery_date);        
            jQuery('#pv_postcode_response').show();        

            function isAvailable(date) {
              dmy = date.getDate() + "-" + (date.getMonth()+1) + "-" + date.getFullYear();
              //console.log(dmy+' : '+($.inArray(dmy, availableDates)));
              if ($.inArray(dmy, availableDates) != -1) {
                return [true, "","Available"];
              } else {
                return [false,"","unAvailable"];
              }
            }

            var availableDates=resp[2].split(',');     
            var datetemp=availableDates[0].split('-');
            var pv_del_date=addZ(datetemp[0])+"-"+addZ(datetemp[1])+"-"+addZ(datetemp[2]);
            var postcode = parseInt(jQuery('#pv_postcode_text').val());

            if (pv_special_product == 1) {
                if (pv_special_product_perth_metro == 1 && (postcode >= 6000 && postcode <= 6210)) {
                  availableDates = [ pv_special_product_deldate ];
                }
                else if (pv_special_product_sw == 1 && (postcode >= 6230 && postcode <= 6290)) {
                  availableDates = [ pv_special_product_deldate ];
                }
                else {
                  availableDates = '';
                }
            }
            else if (pv_special_collection == 1) {
              if (pv_special_collection_deldate_pm != '' && (postcode >= 6000 && postcode <= 6210)) {
                availableDates = pv_special_collection_deldate_pm.split(',');
              }
              else if (pv_special_collection_deldate_sw != '' && (postcode >= 6230 && postcode <= 6290)) {
                availableDates = pv_special_collection_deldate_sw.split(',');
              }
              else {
                availableDates = '';
              }
          }
            else if (document.querySelector('#christmas_order') && document.querySelector('#christmas_order').checked) {
                if (pv_remove_day == 1 && (postcode >= 6000 && postcode <= 6210)) {
                  availableDates = [ '14-4-2022' ];
                }
                else if (pv_remove_day == 1 && (postcode >= 6230 && postcode <= 6290)) {
                  availableDates = [ '14-4-2022' ];
                }
                else {
                  if (postcode >= 6230 && postcode <= 6290) {
                      availableDates = [ '14-4-2022' ];
                  }
                  else {
                      availableDates = [ '12-4-2022', '13-4-2022', '14-4-2022' ];
                  }
                }
            }
            else if (pv_truffles == 1) {
                if (postcode >= 6000 && postcode <= 6210) {
                    if (pv_remove_day == 1) {
                        var adjusted_date = getNextWeekAfterMonday(4);
                    }
                    else {
                        var adjusted_date = getNextWeekAfterMonday(3);
                    }

                    availableDates = [ adjusted_date.getDate() + "-" + (adjusted_date.getMonth() + 1) + "-" + adjusted_date.getFullYear() ];
                }
                else {
                    availableDates = '';
                }
            }
            else if (pv_bread == 1) {
                if (postcode >= 6000 && postcode <= 6210) {
                  var current_date = new Date();
                  var adjusted_date;
                  availableDates = new Array();
                  var day_of_week = current_date.getDay();
                  
                  if (pv_remove_day == 1) {
                      if (day_of_week == 0) {
                        	adjusted_date = getNextWeekAfterMonday(2);
                            availableDates[0] = adjusted_date.getDate() + "-" + (adjusted_date.getMonth() + 1) + "-" + adjusted_date.getFullYear();

                            adjusted_date = getNextWeekAfterMonday(3);
                            availableDates[1] = adjusted_date.getDate() + "-" + (adjusted_date.getMonth() + 1) + "-" + adjusted_date.getFullYear();

                            adjusted_date = getNextWeekAfterMonday(4);
                            availableDates[2] = adjusted_date.getDate() + "-" + (adjusted_date.getMonth() + 1) + "-" + adjusted_date.getFullYear();
                      }
                      else {
                          if (current_date < getCutOff(1, 11)) {
                            adjusted_date = getNextWeekAfterMonday(2 - 7);
                            availableDates[0] = adjusted_date.getDate() + "-" + (adjusted_date.getMonth() + 1) + "-" + adjusted_date.getFullYear();

                            adjusted_date = getNextWeekAfterMonday(3 - 7);
                            availableDates[1] = adjusted_date.getDate() + "-" + (adjusted_date.getMonth() + 1) + "-" + adjusted_date.getFullYear();

                            adjusted_date = getNextWeekAfterMonday(4 - 7);
                            availableDates[2] = adjusted_date.getDate() + "-" + (adjusted_date.getMonth() + 1) + "-" + adjusted_date.getFullYear();
                          }
                          else if (current_date < getCutOff(2, 11)) {
                            adjusted_date = getNextWeekAfterMonday(3 - 7);
                            availableDates[0] = adjusted_date.getDate() + "-" + (adjusted_date.getMonth() + 1) + "-" + adjusted_date.getFullYear();

                            adjusted_date = getNextWeekAfterMonday(4 - 7);
                            availableDates[1] = adjusted_date.getDate() + "-" + (adjusted_date.getMonth() + 1) + "-" + adjusted_date.getFullYear();
                          }
                          else {
                            adjusted_date = getNextWeekAfterMonday(2);
                            availableDates[0] = adjusted_date.getDate() + "-" + (adjusted_date.getMonth() + 1) + "-" + adjusted_date.getFullYear();

                            adjusted_date = getNextWeekAfterMonday(3);
                            availableDates[1] = adjusted_date.getDate() + "-" + (adjusted_date.getMonth() + 1) + "-" + adjusted_date.getFullYear();

                            adjusted_date = getNextWeekAfterMonday(4);
                            availableDates[2] = adjusted_date.getDate() + "-" + (adjusted_date.getMonth() + 1) + "-" + adjusted_date.getFullYear();
                          }
                      }
                  }
                  else {
                      if (day_of_week == 0) {
                      		adjusted_date = getNextWeekAfterMonday(2);
                            availableDates[0] = adjusted_date.getDate() + "-" + (adjusted_date.getMonth() + 1) + "-" + adjusted_date.getFullYear();

                            adjusted_date = getNextWeekAfterMonday(3);
                            availableDates[1] = adjusted_date.getDate() + "-" + (adjusted_date.getMonth() + 1) + "-" + adjusted_date.getFullYear();

                            adjusted_date = getNextWeekAfterMonday(4);
                            availableDates[2] = adjusted_date.getDate() + "-" + (adjusted_date.getMonth() + 1) + "-" + adjusted_date.getFullYear();

                            adjusted_date = getNextWeekAfterMonday(5);
                            availableDates[3] = adjusted_date.getDate() + "-" + (adjusted_date.getMonth() + 1) + "-" + adjusted_date.getFullYear();
                      }
                      else {
                          if (current_date < getCutOff(1, 11)) {
                            adjusted_date = getNextWeekAfterMonday(2 - 7);
                            availableDates[0] = adjusted_date.getDate() + "-" + (adjusted_date.getMonth() + 1) + "-" + adjusted_date.getFullYear();

                            adjusted_date = getNextWeekAfterMonday(3 - 7);
                            availableDates[1] = adjusted_date.getDate() + "-" + (adjusted_date.getMonth() + 1) + "-" + adjusted_date.getFullYear();

                            adjusted_date = getNextWeekAfterMonday(4 - 7);
                            availableDates[2] = adjusted_date.getDate() + "-" + (adjusted_date.getMonth() + 1) + "-" + adjusted_date.getFullYear();

                            adjusted_date = getNextWeekAfterMonday(5 - 7);
                            availableDates[3] = adjusted_date.getDate() + "-" + (adjusted_date.getMonth() + 1) + "-" + adjusted_date.getFullYear();
                          }
                          else if (current_date < getCutOff(2, 11)) {
                            adjusted_date = getNextWeekAfterMonday(3 - 7);
                            availableDates[0] = adjusted_date.getDate() + "-" + (adjusted_date.getMonth() + 1) + "-" + adjusted_date.getFullYear();

                            adjusted_date = getNextWeekAfterMonday(4 - 7);
                            availableDates[1] = adjusted_date.getDate() + "-" + (adjusted_date.getMonth() + 1) + "-" + adjusted_date.getFullYear();

                            adjusted_date = getNextWeekAfterMonday(5 - 7);
                            availableDates[2] = adjusted_date.getDate() + "-" + (adjusted_date.getMonth() + 1) + "-" + adjusted_date.getFullYear();
                          }
                          else if (current_date < getCutOff(3, 11)) {
                            adjusted_date = getNextWeekAfterMonday(4 - 7);
                            availableDates[0] = adjusted_date.getDate() + "-" + (adjusted_date.getMonth() + 1) + "-" + adjusted_date.getFullYear();

                            adjusted_date = getNextWeekAfterMonday(5 - 7);
                            availableDates[1] = adjusted_date.getDate() + "-" + (adjusted_date.getMonth() + 1) + "-" + adjusted_date.getFullYear();
                          }
                          else if (current_date < getCutOff(4, 11)) {
                            adjusted_date = getNextWeekAfterMonday(5 - 7);
                            availableDates = [ adjusted_date.getDate() + "-" + (adjusted_date.getMonth() + 1) + "-" + adjusted_date.getFullYear() ];
                          }
                          else {
                            adjusted_date = getNextWeekAfterMonday(2);
                            availableDates[0] = adjusted_date.getDate() + "-" + (adjusted_date.getMonth() + 1) + "-" + adjusted_date.getFullYear();

                            adjusted_date = getNextWeekAfterMonday(3);
                            availableDates[1] = adjusted_date.getDate() + "-" + (adjusted_date.getMonth() + 1) + "-" + adjusted_date.getFullYear();

                            adjusted_date = getNextWeekAfterMonday(4);
                            availableDates[2] = adjusted_date.getDate() + "-" + (adjusted_date.getMonth() + 1) + "-" + adjusted_date.getFullYear();

                            adjusted_date = getNextWeekAfterMonday(5);
                            availableDates[3] = adjusted_date.getDate() + "-" + (adjusted_date.getMonth() + 1) + "-" + adjusted_date.getFullYear();
                          }
                      }
                  }

              }
              else {
                  availableDates = '';
              }
            }
            else if (pv_remove_day == 1) {
                var dates_arr = availableDates;
                for (var x = 0 ; x < dates_arr.length ; x++) {
                    var parts = dates_arr[x].split('-');    
                    var mydate = new Date(parts[2], parts[1] - 1, parts[0]);
                    var myday = mydate.getDay();

                    if ((postcode >= 6230 && postcode <= 6290) && myday != 4) {
                        availableDates = jQuery.grep(availableDates, function(value) {
                          return value != dates_arr[x];
                        });
                    }
                    else if (postcode >= 6000 && postcode <= 6210) {
                        var current_date = new Date();

                        if (current_date > getCutOff(1, 14) && myday != 5 && myday != 4) {
                          availableDates = jQuery.grep(availableDates, function(value) {
                            return value != dates_arr[x];
                          });
                        }
                        else if (myday != 5 && myday != 4 && myday != 3) {
                          availableDates = jQuery.grep(availableDates, function(value) {
                            return value != dates_arr[x];
                          });
                        }
                  	}
                  	else if (postcode == 99998 && myday != 3) {
						            availableDates = jQuery.grep(availableDates, function(value) {
                          return value != dates_arr[x];
                        });
                  	}
                }

                // Override delivery dates
//                 if (postcode >= 6230 && postcode <= 6290) {
//                    availableDates = [ '14-4-2022' ];
//                 }
//                 else if (postcode >= 6000 && postcode <= 6210) {
//                    availableDates = [ '13-4-2022', '14-4-2022' ];
//                 }
            }

            if (availableDates != '') {
              //jQuery(document).ready(function() {
              var current_date = new Date();
              if (pv_special_product == 1) {
                availableDates[0] = pv_special_product_deldate;
                datetemp=availableDates[0].split('-');
                var adjusted_date = new Date(datetemp[2], datetemp[1] - 1, datetemp[0], 0, 0, 0, 0);
                pv_del_date=addZ(adjusted_date.getDate())+"-"+addZ(adjusted_date.getMonth() + 1)+"-"+addZ(adjusted_date.getFullYear());
              }
              else if (pv_special_collection == 1) {
                datetemp=availableDates[0].split('-');
                var adjusted_date = new Date(datetemp[2], datetemp[1] - 1, datetemp[0], 0, 0, 0, 0);
                pv_del_date=addZ(adjusted_date.getDate())+"-"+addZ(adjusted_date.getMonth() + 1)+"-"+addZ(adjusted_date.getFullYear());
              }
              else if (document.querySelector('#christmas_order') && document.querySelector('#christmas_order').checked) {
                datetemp=availableDates[0].split('-');
                var adjusted_date = new Date(datetemp[2], datetemp[1] - 1, datetemp[0], 0, 0, 0, 0);
                pv_del_date=addZ(adjusted_date.getDate())+"-"+addZ(adjusted_date.getMonth() + 1)+"-"+addZ(adjusted_date.getFullYear());
              }
              else if (current_date > getCutOff(5, 16) && pv_truffles == 1) {
                if (pv_remove_day == 1) {
                    var adjusted_date = getNextWeekAfterMonday(4);
                }
                else {
                    var adjusted_date = getNextWeekAfterMonday(3);
                }

                adjusted_date.setDate(adjusted_date.getDate() + 7);
                pv_del_date=addZ(adjusted_date.getDate())+"-"+addZ(adjusted_date.getMonth() + 1)+"-"+addZ(adjusted_date.getFullYear());
                availableDates[0] = adjusted_date.getDate() + "-" + (adjusted_date.getMonth() + 1) + "-" + adjusted_date.getFullYear();
              }
              else if ((current_date > getCutOff(1, 14) && current_date < getCutOff(2, 14)) && (postcode >= 6000 && postcode <= 6210) && pv_remove_day == 1) {
                var adjusted_date = getNextWeekAfterMonday(3 - 7);
                var adjusted_date2 = getNextWeekAfterMonday(4 - 7);
                //var adjusted_date3 = getNextWeekAfterMonday(2 + 7);

                pv_del_date=addZ(adjusted_date.getDate())+"-"+addZ(adjusted_date.getMonth() + 1)+"-"+addZ(adjusted_date.getFullYear());
                availableDates[0] = adjusted_date.getDate() + "-" + (adjusted_date.getMonth() + 1) + "-" + adjusted_date.getFullYear();
                availableDates[1] = adjusted_date2.getDate() + "-" + (adjusted_date2.getMonth() + 1) + "-" + adjusted_date2.getFullYear();
                //availableDates[2] = adjusted_date3.getDate() + "-" + (adjusted_date3.getMonth() + 1) + "-" + adjusted_date3.getFullYear();
              }
              else if (pv_bread == 1) {
                // Override Bread and Veggie
              }
              else if (current_date > getCutOff(2, 14) && pv_remove_day == 1) {
                /*
                datetemp=availableDates[0].split('-');
                var adjusted_date = new Date(datetemp[2], datetemp[1] - 1, datetemp[0], 0, 0, 0, 0);
                //adjusted_date.setDate(adjusted_date.getDate() + 7);
                var diffDays = Math.ceil((adjusted_date - current_date) / (1000 * 60 * 60 * 24)); 
                console.log(getNextWeekAfterMonday(3));
                if (diffDays >= 7) {
                  adjusted_date.setDate(adjusted_date.getDate() - 7);
                }
                else {
                  adjusted_date.setDate(adjusted_date.getDate() + 7);
                }
                */

                if (postcode >= 6230 && postcode <= 6290) {
                    var adjusted_date = getNextWeekAfterMonday(3);

                    // Adding another week to push delivery date to two weeks
                    // var adjusted_date = getNextWeekAfterMonday(3 + 7);
                }
                else if (postcode >= 6000 && postcode <= 6210) {
                    var adjusted_date = getNextWeekAfterMonday(2);
                    var adjusted_date2 = getNextWeekAfterMonday(3);
                    var adjusted_date3 = getNextWeekAfterMonday(4);

                    // Adding another week to push delivery date to two weeks
                    // ar adjusted_date = getNextWeekAfterMonday(3 + 7);
                    // var adjusted_date2 = getNextWeekAfterMonday(4 + 7);
                }
                else if (postcode == 99998) {
                    var adjusted_date = getNextWeekAfterMonday(2);
                }

                pv_del_date=addZ(adjusted_date.getDate())+"-"+addZ(adjusted_date.getMonth() + 1)+"-"+addZ(adjusted_date.getFullYear());
                availableDates[0] = adjusted_date.getDate() + "-" + (adjusted_date.getMonth() + 1) + "-" + adjusted_date.getFullYear();
                
                if (adjusted_date2) {
                  availableDates[1] = adjusted_date2.getDate() + "-" + (adjusted_date2.getMonth() + 1) + "-" + adjusted_date2.getFullYear();
                } 

                if (adjusted_date3) {
                  availableDates[2] = adjusted_date3.getDate() + "-" + (adjusted_date3.getMonth() + 1) + "-" + adjusted_date3.getFullYear();
                } 

                // Override delivery dates
//                 if (postcode >= 6230 && postcode <= 6290) {
//                   availableDates[0] = '14-4-2022';
//                 }
//                 else if (postcode >= 6000 && postcode <= 6210) {
//                   availableDates[0] = '13-4-2022';
//                   availableDates[1] = '14-4-2022';
//                 }
//                 else if (postcode == 99998) {
//                   adjusted_date = '14-4-2022';
//                 }
              }
              else {
                datetemp=availableDates[0].split('-');
                pv_del_date=addZ(datetemp[0])+"-"+addZ(datetemp[1])+"-"+addZ(datetemp[2]);
              }

              jQuery( "#delivery-date-inline" ).datepicker("destroy");
              if (jQuery( "#delivery-date" ).hasClass('hasDatepicker')) jQuery( "#delivery-date" ).removeClass('hasDatepicker');
              jQuery( "#delivery-date" ).click(function() {
                $("#delivery-date-inline").toggle();
              });
              jQuery( "#delivery-date-inline" ).datepicker({ 
                beforeShowDay: isAvailable, 
                dateFormat: 'dd-mm-yy',
                altField: "#delivery-date",
                onSelect: function(date) {
                    //console.log(date) 
                    jQuery( ".checkout-btn" ).css('display', 'flex');
                    jQuery( ".deliveryDate-error-message" ).hide();

                    jQuery.ajax({
                      type: 'POST',
                      url: '/cart/update.js',
                      data: 'attributes[Postcode]=' + jQuery('#pv_postcode_text').val() + '&attributes[Delivery-Date]=' + jQuery('#delivery-date').val() + '&attributes[Delivery-Date-Request-Time]=' + jQuery('#delivery-date-request-time').val(),
                      dataType: 'text',
                      success: function(responseData, textStatus, jqXHR) {
                          console.log('updated cart');
                      },
                      error: function (responseData, textStatus, errorThrown) {
                        console.log(errorThrown);
                      }
                    }); 

		              jQuery( ".cart-out-of-stock-option" ).show();
                  jQuery( ".cart-ordernote" ).show();

                  if (jQuery( "#delivery-date" ).val() !== '' ) {
                    jQuery('.cart-pvc-sidebar__delivery-date').addClass('cart-pvc-sidebar__success'); 

                    if (jQuery('.cart-pvc-sidebar__subscription-delivery-day').length) {
                      jQuery('.cart-pvc-sidebar__subscription-delivery-day ul li').remove(); 

                      if (pv_state.includes('south west')) {
                        var deliveryDays = window.CustomTheme.deliverydays.southwest_orders;
                        deliveryDays = deliveryDays.split(', ');
                      } else if (pv_state.includes('perth metro')) {
                        if (has_subscription_veggie_product) {
                          var deliveryDays = window.CustomTheme.deliverydays.perth_metro_veggie_box;
                          deliveryDays = deliveryDays.split(', ');
                        } else {
                          var deliveryDays = window.CustomTheme.deliverydays.perth_metro_orders;
                          deliveryDays = deliveryDays.split(', ');
                        }
                      }

                      if (deliveryDays.length > 1 ) {
                        for (let i = 0; i < deliveryDays.length; i++) {
                          jQuery('.cart-pvc-sidebar__subscription-delivery-day ul').append('<li>' + deliveryDays[i]  + '</li>');
                        }
                      } else {
                        jQuery('.cart-pvc-sidebar__subscription-delivery-day ul').append('<li>' + deliveryDays  + '</li>');
                      }
                        
                      jQuery('.cart-pvc-sidebar__subscription-delivery-day').removeClass('cart-pvc-sidebar__hide');
                      jQuery('.deliverdays-error-message').show();

                    } else {
                      if(jQuery('.cart-pvc-sidebar__oos-preference') != null) {
                        jQuery('.cart-pvc-sidebar__oos-preference').removeClass('cart-pvc-sidebar__hide');
                      }
                      if(jQuery('.cart-pvc-sidebar__order-note') != null) {
                        jQuery('.cart-pvc-sidebar__order-note').removeClass('cart-pvc-sidebar__hide');
                      }
                    }
                    // if(jQuery('.cart-checkout button[name="checkout"], .cart-checkout button[name="checkout-dummy"]').attr('disabled')) {
                    //   jQuery('.cart-checkout button[name="checkout"], .cart-checkout button[name="checkout-dummy"]').attr('disabled', false);
                    // }
                  } 

                  jQuery("#delivery-date-inline").removeClass("show");
                  jQuery("#delivery-date-inline").hide();
                } 
              });

              $(".cart-pvc-sidebar__subscription-delivery-day ul").on('click', 'li', function() { 
                $("#subscription-orders-delivery-day").val( $(this).html() );
                $(".cart-pvc-sidebar__subscription-delivery-day summary span").html( $(this).html() )

                $(this).closest("details").removeAttr("open", '');

                
                if ($("#subscription-orders-delivery-day").val() != '' ){
                  jQuery('.deliverdays-error-message').hide();
                  jQuery('.cart-pvc-sidebar__subscription-delivery-day').addClass("cart-pvc-sidebar__success");
                  if(jQuery('.cart-pvc-sidebar__oos-preference') != null) {
                    jQuery('.cart-pvc-sidebar__oos-preference').removeClass('cart-pvc-sidebar__hide');
                  }
                  if(jQuery('.cart-pvc-sidebar__order-note') != null) {
                    jQuery('.cart-pvc-sidebar__order-note').removeClass('cart-pvc-sidebar__hide');
                  }
                } else {
                  jQuery('.deliverdays-error-message').show();
                  jQuery('.cart-pvc-sidebar__subscription-delivery-day').removeClass("cart-pvc-sidebar__success");
                }
              });

              jQuery( ".cart-pvc-sidebar__oos-preference li" ).each(function() {
                $(this).click(function() {
                  $("#oos-preference").val( $(this).html() );
                  $(".cart-pvc-sidebar__oos-preference summary").attr("data-oos-option", $(this).attr("data-oos-option"));
                  $(".cart-pvc-sidebar__oos-preference summary span").html( $(this).html() )

                  $(this).closest("details").removeAttr("open", '');

                  if( $(".cart-pvc-sidebar__oos-preference summary").attr("data-oos-option") !== "0" ) {
                    jQuery('.cart-checkout button[name="checkout"], .cart-checkout button[name="checkout-dummy"]').attr('disabled', false);
                    jQuery('.cart-pvc-sidebar__oos-preference').addClass("cart-pvc-sidebar__success");
                    jQuery('.outOfStock-error-message').hide();
                  } else {
                    jQuery('.cart-checkout button[name="checkout"], .cart-checkout button[name="checkout-dummy"]').attr('disabled', '');
                    jQuery('.cart-pvc-sidebar__oos-preference').removeClass("cart-pvc-sidebar__success");
                    jQuery('.outOfStock-error-message').show();
                  }
                });
              });

              jQuery(".cart-pvc-sidebar__oos-preference summary span").html( jQuery('.cart-pvc-sidebar__oos-preference li[data-oos-option="0"]').html() );
              jQuery(".cart-pvc-sidebar__oos-preference summary").attr("data-oos-option", "0");
              jQuery('.cart-pvc-sidebar__oos-preference').removeClass("cart-pvc-sidebar__success");
              jQuery('.cart-checkout button[name="checkout"], .cart-checkout button[name="checkout-dummy"]').attr('disabled', '');
              jQuery('.outOfStock-error-message').hide();

              jQuery('.cart-pvc-sidebar__order-note').addClass('cart-pvc-sidebar__hide');
              jQuery('.cart-pvc-sidebar__oos-preference').addClass('cart-pvc-sidebar__hide');

              if (jQuery('.cart-pvc-sidebar__subscription-delivery-day').length) {
                $("#subscription-orders-delivery-day").val('');
                $(".cart-pvc-sidebar__subscription-delivery-day summary span").html('Select Day');
                jQuery('.cart-pvc-sidebar__subscription-delivery-day').addClass('cart-pvc-sidebar__hide');
                jQuery('.deliverdays-error-message').hide(); 
              }

              jQuery( "#delivery-date" ).val('');
              //jQuery( "#delivery-date" ).val(pv_del_date);
              jQuery( ".cart-attribute__field" ).show();
              jQuery( "#delivery-date" ).show();

              jQuery( ".delivery-date" ).click();
              jQuery('.tab').addClass('success-area');

              jQuery('.cart-pvc-sidebar__postcode').addClass('cart-pvc-sidebar__success');
              jQuery('.cart-pvc-sidebar__delivery-date').removeClass('cart-pvc-sidebar__hide');
              jQuery('.cart-pvc-sidebar__delivery-date').removeClass('cart-pvc-sidebar__success');
              if (window.innerWidth <= 768) {
                jQuery( ".tablinks.delivery-area" ).addClass('success');
                jQuery( "#deliveryArea" ).addClass('success');
                if (jQuery( "#delivery-date" ).val() == '' ) {
                  jQuery( ".deliveryDate-error-message" ).css('display', 'flex');
                  jQuery( ".minimum-spend-error-message" ).hide();
                } else {
                  jQuery( ".checkout-btn" ).css('display', 'flex');
                  jQuery( ".minimum-spend-error-message" ).hide();
                  jQuery( ".cart-out-of-stock-option" ).show();
                  jQuery( ".cart-ordernote" ).show();
                } 
              }
              else {
                jQuery( ".tablinks.delivery-area" ).addClass('success');
                jQuery( "#deliveryArea" ).addClass('success');

                if (jQuery( "#delivery-date" ).val() == '') {
                  jQuery( ".deliveryDate-error-message" ).css('display', 'flex');
                  jQuery( ".minimum-spend-error-message" ).hide();
                } else {
                  jQuery( ".checkout-btn" ).css('display', 'flex');
                  jQuery( ".minimum-spend-error-message" ).hide();
                  jQuery( ".cart-out-of-stock-option" ).show();
                  jQuery( ".cart-ordernote" ).show();
                }
              }
              

              if (pv_subscription == 1) {
                if (postcode >= 6230 && postcode <= 6290) {
                    //jQuery("#discount").val('FREE_SHIPPING_SW');
                    jQuery("#load-discount").attr('src', '/discount/FREE_SHIPPING_SW');
                }
                else if (postcode >= 6000 && postcode <= 6210) {
                    //jQuery("#discount").val('FREE_SHIPPING_METRO');
                    jQuery("#load-discount").attr('src', '/discount/FREE_SHIPPING_METRO');
                }
              }
              //} );       
              let request_time = new Date(); 
              let current_date_time = request_time.getFullYear() + "-" + addZ((request_time.getMonth()+1)) + "-" + addZ(request_time.getDate()) + "T"  
                + addZ(request_time.getHours()) + ":"  + addZ(request_time.getMinutes()) + ":" + addZ(request_time.getSeconds());
              jQuery('#delivery-date-request-time').val(current_date_time);
            }
            else {
             	  var pv_delivery_msg='<div class="pv_minimum_order">No available delivery date.</div>';
                jQuery('div.pv_shipping_msg.pv_d-flex_end').hide();

                jQuery('#pv_delivery_msg').html(pv_delivery_msg);
                jQuery('.cart__submit').prop( "disabled", true ).hide();
              	jQuery( ".cart-attribute__field" ).hide();
              	jQuery( "#delivery-date" ).hide();
                jQuery('.tab').removeClass('success-area');

                if (window.innerWidth <= 768) {
                  jQuery( ".tablinks.delivery-area" ).removeClass('success');
                  jQuery( "#deliveryArea" ).removeClass('success');
                  jQuery( ".checkout-btn" ).hide();
                  jQuery( ".minimum-spend-error-message" ).css('display', 'flex');
                  jQuery( ".minimum-spend-error-message p" ).html('No available delivery date.');
                  jQuery( ".cart-out-of-stock-option" ).hide();
                  jQuery( ".cart-ordernote" ).hide();
                }
                else {
                  jQuery( ".tablinks.delivery-area" ).removeClass('success');
                  jQuery( "#deliveryArea" ).removeClass('success');
                  jQuery( ".checkout-btn" ).hide();
                  jQuery( ".minimum-spend-error-message" ).css('display', 'flex');
                  jQuery( ".minimum-spend-error-message span" ).html('No available delivery date.');
                  jQuery( ".cart-out-of-stock-option" ).hide();
                  jQuery( ".cart-ordernote" ).hide();
                }
            }
          }
          else {
            var pv_delivery_msg='<div class="pv_minimum_order">You need to spend $' + pv_minimum_order + ' or more before you can checkout!</div>';
            jQuery('div.pv_shipping_msg.pv_d-flex_end').hide();
            
            jQuery('#pv_delivery_msg').html(pv_delivery_msg);
          	jQuery('.cart__submit').prop( "disabled", true ).hide();

            jQuery( ".tablinks.delivery-area" ).removeClass('success');
            jQuery( ".checkout-btn" ).hide();
            jQuery( ".minimum-spend-error-message" ).show();
            jQuery( ".minimum-spend-error-message span" ).html('You need to spend $' + pv_minimum_order + ' or more before you can checkout!');
            jQuery( ".cart-out-of-stock-option" ).hide();
            jQuery( ".cart-ordernote" ).hide();
          }
        }
        else {
          //jQuery('#pv_postcode_response').html('');
          jQuery('#pv_postcode_response').hide('');
          jQuery('#pv_delivery_msg').html('');
          jQuery('.cart__submit').prop( "disabled", true ).hide();
          jQuery('#pv_undeliverable_msg').hide();
          jQuery('div.pv_shipping_msg.pv_d-flex_end').show();
          jQuery('#pv_undeliverable_msg').html(responseData);

          jQuery('.tab').addClass('success-area');
          jQuery( ".tablinks.delivery-area" ).removeClass('success');
          jQuery( ".checkout-btn" ).hide();
          jQuery( ".minimum-spend-error-message" ).show();
          jQuery( ".minimum-spend-error-message span" ).html(responseData);
          jQuery( ".cart-out-of-stock-option" ).hide();
          jQuery( ".cart-ordernote" ).hide();

          if(jQuery('.cart-pvc-sidebar__postcode').hasClass('cart-pvc-sidebar__success')) {
            jQuery('.cart-pvc-sidebar__postcode').removeClass('cart-pvc-sidebar__success');
          }
          if(!jQuery('.cart-pvc-sidebar__delivery-date').hasClass('cart-pvc-sidebar__hide')) {
            jQuery('.cart-pvc-sidebar__delivery-date').addClass('cart-pvc-sidebar__hide');
          }
          if(!jQuery('.cart-pvc-sidebar__delivery-day').hasClass('cart-pvc-sidebar__hide')) {
            jQuery('.cart-pvc-sidebar__delivery-day').addClass('cart-pvc-sidebar__hide');
            jQuery('.deliverdays-error-message').hide();
          }
          
        }
      },
      error: function (responseData, textStatus, errorThrown) {
        console.log(errorThrown);
      }
    }); 
  });
});
